import React, { useCallback } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportSalesFilters, getReportSalesUnitAction } from "redux/actions/Reports/reportSales/reportSalesActions";

export const ReportSalesUnitView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station, unit } = useSelector(({ reportSales }) => reportSales);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportSalesUnitAction({ startDate, endDate, station, unit, isPdf }))
  }, [startDate, endDate, station, unit]);

  return (
    <GlobalBox title="Reporte de venta del día por Unidad" icon={<AssessmentIcon />} >
      {isLoadingComp?.loadingReportSales ? <LoadingComponent /> :
        <TableInputs
          reducer="reportSales"
          dates
          stations
          units
          isWholesaler
          maxDate={newDate()}
          dispatchAction={setReportSalesFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={(e) => handleSubmit(e, false)}
        />
      }
    </GlobalBox>
  );
};
